import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimalSelectionTransportDialogComponent } from './animal-selection-transport-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { DialogLayoutModule } from '@tcc-mono/shared/ui/dialog-layout';

@NgModule({
  imports: [
    CommonModule,
    DialogLayoutModule,
    ReactiveFormsModule,
    IonicModule,
    FontAwesomeModule,
    TranslocoModule
  ],
  declarations: [AnimalSelectionTransportDialogComponent],
  exports: [AnimalSelectionTransportDialogComponent]
})
export class AnimalSelectionTransportDialogModule { }
